"use client";
import React from "react";
import Link from "next/link";
import { Button, Icon } from "@chakra-ui/react";
import { FaLaptop } from "@onemind-services-llc/react-icons-ng/fa";
import { useDashboardLoginURL } from "@/hooks/useDashboardLoginURL";

type Props = {
  id: number;
  display: string;
  product_id: number;
};

const RenderBookTrial = (props: Props) => {
  const { id, display, product_id } = props;
  const dashboardLoginURL = useDashboardLoginURL();

  let nextURL = `/app/learning-labs/buy-product/${id}?product=`;
  nextURL +=
    '{"display": "' +
    display +
    '", "product_id": ' +
    product_id +
    ', "account_host": "cmlbooking.checkfront.com"}';

  const href = `${dashboardLoginURL}?next=${encodeURIComponent(nextURL)}`;

  return (
    <Button
      as={Link}
      borderRadius="4px"
      href={href}
      leftIcon={<Icon as={FaLaptop} fontSize={"20px"} />}
      padding={"7px 15px"}
      background={"black"}
      color="white"
      border={"1px solid black"}
      _hover={{
        background: "white",
        color: "black",
      }}
    >
      BOOK YOUR TRIAL
    </Button>
  );
};

export default RenderBookTrial;
